// extracted by mini-css-extract-plugin
export default {"button":"Item_button__+54eA","sAdminIcon":"Item_sAdminIcon__qTo6m"};